import React, { useState, useEffect } from "react";
import {
  Typography,
  Select,
  MenuItem,
  TextField,
  Button,
  Paper,
  Box,
  makeStyles,
  Grid,
  FormControl,
  TablePagination,
  InputLabel,
} from "@material-ui/core";
import instance from "api/globalaxios";
import { useSnackbar } from "contexts/SnackbarContext";
import fileDownload from "js-file-download";
import Swal from "sweetalert2";
import MasterTable from "./MasterTable";
import { Print } from "@material-ui/icons";
import AdvocateForm from "./AdvocateForm";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import { RequiredLabel } from "features/loginTdsat/Signup";
import JudgesDesignationInput from "./JudgesDesignationInput";

export async function getMasterTypes(){
    return await instance({
      method: "get",
      url: `tdsat/master_types/`
    });
}

export async function getDetailsOfMasterTypeSelected(type, page){
    return await instance({
      method: "get",
      url: `tdsat/master/${type}/?show_pagination=true&page=${page}`
    });
}

export async function deleteRowOfMasterTable(type, id){
    return await instance({
      method: "delete",
      url: `tdsat/master/${type}/${id}`
    });
}

export async function createMasterObject(type, data){
    return await instance({
        method: "post",
        url: `tdsat/master/${type}/`,
        data
    });
}

export async function updateRowOfMasterTable(type, id, data){
    return await instance({
      method: "put",
      url: `tdsat/master/${type}/${id}/`,
      data
    });
}


const useStyles = makeStyles((theme) => ({
    form: {
      maxWidth: 800,
      margin: '0 auto',
      padding: theme.spacing(3),
      display:  'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      marginBottom: theme.spacing(2.5),
      marginTop: theme.spacing(2.5),
    },
    paper: {
      padding: theme.spacing(4),
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      width: 600,
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(1),
      borderRadius: '10px'
    },
    paperTable: {
        padding: theme.spacing(4),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        width: 800,
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(1),
        borderRadius: '10px'
    },
    label: {
        color: '#121212',
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.3125rem',
        textAlign: 'left',
        marginBottom: '0.2rem',
      },
      submitButton: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '24px'
      },
      buttonPay: {
        padding: theme.spacing(1),
        borderRadius: 12,
        width: '30%',
        display: 'flex',
    },
    titleTop: {
        fontSize: '20px',
        fontWeight: 700,
    },
    tableRow: {
        display: 'flex',
        gap: '1rem',
        marginTop: '1rem',
        paddingBottom: '1rem',
        width: '100%',
        borderBottom: '1px solid #4B4E56',
    },
    tableBtn: {
        background: '#F4F8FF',
        width: '180px',
        borderRadius: '0px',
        color: 'black',
        fontSize: '14px',
        fontWeight: 700,
        cursor: 'pointer',
    },
    noBorders: {
        border: 'none',
        fontSize: '15px',
        
      },
      formAdvocate: {
        padding: '20px',
        display: 'flex',
        gap: '10px',
        width: '60%',
        // marginLeft: 'auto',
        // marginRight: 'auto',
      },
    pagination: {
      marginTop: theme.spacing(2),
    },
}));

const MasterCis = () => {
    const classes = useStyles();
    const [masterTypes, setMasterTypes] = useState([]); // Dropdown options
    const [selectedMasterType, setSelectedMasterType] = useState("");
    const [tableData, setTableData] = useState([]); // Table rows
    const [editIndex, setEditIndex] = useState(-1); // Track row being edited
    const [newRow, setNewRow] = useState({ code: "", shortName: "", name: "" , designation: "", type: ""}); // For adding a new row
    const [isLoading, setIsLoading] = useState(true);
    const { showSnackbar } = useSnackbar();
    const [selectedLabel, setSelectedLabel] = useState('');
    const [anchorEl, setAnchorEl] = useState(null); // State for Popover anchor
    const [countPagination, setCountPagination] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loadingTableData, setLoadingTableData] = useState(false);

    const SUBJECT_CATEGORY_CHOICES = [
      {
        "label": "Telecom",
        "value": "telecom"
      },
      {
        "label": "BroadCasting",
        "value": "broadcasting"
      },
      {
        "label": "IT",
        "value": "it"
      },
      {
        "label": "Airport",
        "value": "airport"
      },
      {
        "label": "Other",
        "value": "other"
      },
    ]

    // Function to handle button click and open the Popover
    const handleButtonClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    // Function to close the Popover
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl);

    useEffect(() => {
        const fetchMasterTypes = async () => {
          try {
            const response = await getMasterTypes();
            setMasterTypes(response?.data);  
          } catch (error) {
            console.error("Error fetching Master Types", error);
          }
        };
    
        fetchMasterTypes();
    }, []);

    const handleAPICall = async (page = 1) => {
      setLoadingTableData(true);
      try {
        const response = await getDetailsOfMasterTypeSelected(selectedMasterType, page); 
        const data = response?.data?.results || [];
        
        if (data.length > 0) {
          setTableData(data);
          setCountPagination(response?.data?.count)
        } else {
          setTableData([]);
          showSnackbar("No records found for selected Master Type", 'warning')
        }
        setLoadingTableData(false);
      } catch (error) {
          console.error("Error fetching details:", error);
      } finally {
          setLoadingTableData(false); // Hide loader
      }
    }

     // Fetch data on Search button click
    const handleSearch = async (event, page = 1) => {
        if (!selectedMasterType) {
            showSnackbar("Please select a Master Type", 'error')
            return;
        }
        setIsLoading(true);
        try {
          await handleAPICall(page);
          setIsLoading(false);
        } catch (error) {
            console.error("Error fetching details:", error);
        } finally {
            setIsLoading(false); // Hide loader
        }

    };

    const handlePrintMasterReport = async () => {
        try {
            const response = await instance.get(`tdsat/master/${selectedMasterType}/generate`, {responseType: "blob"});
            fileDownload(
                response.data,
                `MasterReport-${selectedMasterType}.pdf`
            );
            Swal.fire({
                title: "Print Slip",
                text: "Report Downloaded Successfully",
                icon: "success"
            });
        }catch (error){
            console.error("There was an error fetching the case data!", error);
        }
    };
    
    const handleAddRow = async () => {
        if ((!newRow.code && (selectedMasterType !== 'judges' && selectedMasterType !== 'subjects')) || !newRow.name) {
            showSnackbar("Short Name and Name are required fields.", 'error');
            return;
        }
      
        try {
          // Prepare data for the API call
          const data = {
            ...(selectedMasterType === 'judges') ? {} : {
              code: newRow.code,
            },
            ...(selectedMasterType === 'subjects') ? {
              subject_category: newRow.category,
            } : {},
            name: newRow.name,
            designation: newRow.designation,
            type: newRow?.type,
          };
      
          // Make the API call
          const response = await createMasterObject(selectedMasterType, data);
      
          if (response) {
            // Add the new row to the table data
            setTableData([...tableData, { id: response.data.id, ...newRow }]);
            setNewRow({ code: "", shortName: "", name: "", type: "" });
            showSnackbar("New row added successfully!", 'success');
          } else {
            console.error("Failed to add new row:", response);
            showSnackbar("Failed to add new row. Please try again.", 'error');
          }
        } catch (error) {
          console.error("Error adding new row:", error);
          showSnackbar("An error occurred while adding the new row.", 'error');
        }
    };      

    const handleEditRow = async (type, id, updatedData) => {
        try {
          const updatedRow = await updateRowOfMasterTable(type, id, updatedData);
          setTableData((prevData) =>
            prevData.map((row) => (row.id === id ? { ...row, ...updatedRow } : row))
          );
          showSnackbar(updatedRow?.data?.message, 'success');
          handleSearch();
        } catch (error) {
          console.error('Failed to update row:', error);
          if(error?.response?.status === 400){
            showSnackbar(error?.response?.data?.error, 'error');
          }
        }
    };

    // Handle deleting a row
    const handleDeleteRow = async (rowId) => {
        try {
            const response = await deleteRowOfMasterTable(selectedMasterType, rowId); 
      
            if (response) {
                const updatedData = tableData.filter((row) => row.id !== rowId);
                setTableData(updatedData);
                showSnackbar("Deleted row successfully",'success')
            } else {
                const errorData = await response.json();
                showSnackbar("Error Deleting row",'error')
                console.error("Failed to delete row:", errorData);
            }
        } catch (error) {
            console.error("Error deleting row:", error);
        }
      };
    
    const handleChangeMasterType = (e) => {
        const selectedValue = e.target.value;
        setSelectedMasterType(selectedValue);

        // Find the label for the selected value
        const selected = masterTypes.find((item) => item.value === selectedValue);
        setSelectedLabel(selected ? selected.label : '');
        setIsLoading(true)
    };

    const addNewAdvocate = async (data) => {
      try {
        // Make the API call
        const response = await createMasterObject(selectedMasterType, data);
    
        if (response) {
          // Add the new row to the table data
          setTableData([...tableData, { id: (tableData.length + 1), name: data?.advocateName , ...data }]);
          // setNewRow({ code: "", shortName: "", name: "" });
          showSnackbar("New advocate added successfully!", 'success');
        } else {
          console.error("Failed to add new advocate:", response);
          showSnackbar("Failed to add new advocate. Please try again.", 'error');
        }
      } catch (error) {
        console.error("Error adding new advocate:", error);
        showSnackbar("An error occurred while adding the new advocate.", 'error');
      }
    }

    const handleChangePage = async (event, newPage) => {
      setPage(newPage);
      handleAPICall(newPage + 1);
    };

    return (
        <Box component="form" className={classes.form}>
            <Typography variant="h4" align="center" className={classes.title}>
                MASTER
            </Typography>
            <Paper className={classes.paper}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl required fullWidth margin="none" variant="outlined">
                            <RequiredLabel className={classes.label} label={'Master Type'}/>
                            <Select
                                name="type"
                                value={selectedMasterType}
                                onChange={handleChangeMasterType}
                                displayEmpty
                                fullWidth
                            >
                                {masterTypes?.map((masterType, index) => (
                                    <MenuItem key={index} value={masterType.value}>
                                        {masterType.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid className={classes.submitButton}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.buttonPay}
                        onClick={handleSearch}
                    >
                        Search
                    </Button>
            </Grid>
            </Paper>
            {!isLoading &&
                <>
                    <Grid container alignItems="center" style={{justifyContent: 'space-between', marginTop:'80px'}}>
                        <Grid item>
                            <Typography className={classes.titleTop}>{selectedLabel} Master</Typography>
                        </Grid>

                        <Grid item>
                        {selectedMasterType ===  'advocate' &&
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handleButtonClick}
                                style={{ marginTop: '20px', borderRadius: '8px', marginRight: '10px' }}
                            >
                                Add Advocate
                            </Button> }
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handlePrintMasterReport}
                                style={{ marginTop: '20px', borderRadius: '8px' }}
                                endIcon={<Print/>}
                            >
                                Print
                            </Button> 
                        </Grid>
                    </Grid>
                
                    <Paper className={classes.paperTable}>
                        {selectedMasterType !==  'advocate' && 
                            <div className={classes.tableRow}>
                              {selectedMasterType === 'case-type' && (
                                <TextField
                                  fullWidth
                                  required
                                  label='Select Type'
                                  variant='outlined'
                                  select
                                  value={newRow?.type}
                                  onChange={(e) => setNewRow({ ...newRow, type: e.target.value })}
                                  SelectProps={{
                                    native: true,
                                  }}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                >
                                  <option >-Select-</option>
                                  <option value="main_case">Main Case</option>
                                  <option value="application">Application</option>
                                  <option value="document">Document</option>
                                </TextField>
                              )}
                              {(selectedMasterType !== 'judges' && selectedMasterType !== 'subjects') && (
                                <TextField
                                    label={selectedMasterType === 'case-type' ? `${selectedLabel} Short Name` : `${selectedLabel} Code`}
                                    value={newRow.code}
                                    onChange={(e) => setNewRow({ ...newRow, code: e.target.value })}
                                    fullWidth
                                    required
                                    margin="none"
                                    variant="outlined"
                                />
                              )}
                                {selectedMasterType === 'judges' &&
                                    <JudgesDesignationInput
                                      label={`${selectedLabel} Designation`}
                                      name="designation"
                                      value={newRow?.designation}
                                      onChange={(e) => setNewRow({ ...newRow, designation: e.target.value })}
                                      isRequired
                                      
                                    />
                                }
                                {(selectedMasterType === 'subjects') && (
                                  <FormControl required fullWidth margin="none" variant="outlined">
                                    <InputLabel>Subject Category</InputLabel>
                                    <Select
                                        name="category"
                                        label="Subject Category"
                                        value={newRow?.category}
                                        onChange={(e) => setNewRow({ ...newRow, category: e.target.value })}
                                        displayEmpty
                                        fullWidth
                                    >
                                        {SUBJECT_CATEGORY_CHOICES?.map((subjectCategory, index) => (
                                            <MenuItem key={index} value={subjectCategory.value}>
                                                {subjectCategory.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                )}
                                <TextField
                                    label={`${selectedLabel} Name`}
                                    value={newRow.name}
                                    onChange={(e) => setNewRow({ ...newRow, name: e.target.value })}
                                    fullWidth
                                    required
                                    margin="none"
                                    variant="outlined"
                                />
                                <Button variant="contained" color="primary" onClick={handleAddRow} className={classes.buttonPay} endIcon={'+'}>
                                    Add
                                </Button>
                            </div>
                        }
                        {loadingTableData ? (
                          <CircularCenteredLoader/>
                        ) : (
                          <>
                            <MasterTable
                                data={tableData}
                                onAddRow={handleAddRow}
                                onEditRow={handleEditRow}
                                onDeleteRow={handleDeleteRow}
                                classes={classes}
                                selectedLabel={selectedLabel}
                                selectedMasterType={selectedMasterType}
                                SUBJECT_CATEGORY_CHOICES={SUBJECT_CATEGORY_CHOICES}
                            />
                            <div style={{marginLeft:'auto'}}>
                              <TablePagination
                                component="div"
                                count={countPagination}
                                page={page}
                                onChangePage={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                rowsPerPageOptions={[]} 
                                className={classes.pagination}
                              />
                            </div>
                          </>
                        )}
                    </Paper>
                </>
            }
            <AdvocateForm open={open} anchorEl={anchorEl} onClose={handleClose} classes={classes} addNewAdvocate={addNewAdvocate}/>
        </Box>
    );
};

export default MasterCis;
